<template>
  <div id="pagination">
    <ul id="pagi-box">
      <li :class="{ disabled: curPage == 1 }" @click="goPrev"><</li>
      <li v-if="curPage > limit" @click="goHome">1</li>
      <li v-if="curPage > limit" @click="expandPrev">...</li>
      <li
        v-for="page in pageIndex"
        :class="curPage == page ? 'index cur' : 'index'"
        @click="changeCurPage(page)"
      >
        {{ page }}
      </li>
      <li v-if="pageIndex[pageIndex.length-1]<totalPage" @click="expandNext">...</li>
      <li v-if="pageIndex[pageIndex.length-1]<totalPage" @click="goEnd">
        {{ totalPage }}
      </li>
      <li :class="{ disabled: curPage == totalPage }" @click="goNext">></li>
    </ul>
    <span id="total"
      >跳至
      <input v-model="specificPage" id="page" type="number" @change="goPage" />
      页</span
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      limit: 5,
      specificPage: null,
    };
  },
  props: {
    total: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  methods: {
    goHome: function () {
      this.$emit("curPageChange", 1);
    },
    goPrev: function () {
      const page = this.curPage - 1;
      if (page > 0) {
        this.$emit("curPageChange", page);
      }
    },
    goNext: function () {
      if (this.curPage < this.totalPage) {
        const page = this.curPage + 1;
        this.$emit("curPageChange", page);
      }
    },
    goEnd: function () {
      this.$emit("curPageChange", this.totalPage);
    },
    goPage: function () {
      this.$emit("curPageChange", this.specificPage);
    },
    expandPrev: function () {
      const page = this.curPage - this.limit;
      const curPage = page > 1 ? page : 1;
      this.$emit("curPageChange", curPage);
    },
    expandNext: function () {
      const next = this.curPage + this.limit;
      const curPage = next < this.totalPage ? next : this.totalPage;
      this.$emit("curPageChange", curPage);
    },
    changeCurPage: function (page) {
      this.$emit("curPageChange", page);
    },
  },
  computed: {
    totalPage: function () {
      return Math.ceil(this.total / this.pageSize);
    },
    curPage: function () {
      return Number(this.$store.state.params.variables.page);
    },
    pageSize: function () {
      return this.$store.state.params.variables.pageSize;
    },
    pageIndex: function () {
      const len = Math.ceil(this.totalPage / this.limit); // 页码分组后 组数长度
      const mole = this.totalPage % this.limit; // 页码总数与分页组件页数显示限制的模
      let index,
        indexArray = [1]; // 当前页面所在小组序号, 页码小组

      // 找出当前页面所在小组序号
      for (let i = 1; i <= len; i++) {
        if (
          this.limit * (i - 1) < this.curPage &&
          this.curPage <= this.limit * i
        ) {
          index = i;
          break;
        }
      }

      if (index) {
        const start = index * 5 - 5;
        // 生成当前页码小组
        if (index == len && mole) {
          // 判断当前页码分组最后一个小组的长度
          indexArray = Array.from({ length: mole }, (x, i) => i + 1 + start);
        } else {
          indexArray = Array.from(
            { length: this.limit },
            (x, i) => i + 1 + start
          );
        }
      }

      return indexArray;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/stylefunc";
#pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  padding: 10px 20px;
  #total {
    margin-left: 10px;
    font-size: 16px;
    color: #595b56;
    line-height: 24px;
  }
  #page {
    width: 50px;
    border: solid 1px #d9d9d9;
    border-radius: 3px;
    height: 40px;
    text-align: center;
    font-size: 16px;
  }
}
#pagi-box {
  display: flex;
  align-items: center;
  border-radius: 3px;
  list-style: none;
  li {
    padding: 10px 17px;
    border-right: solid 1px #d9d9d9;
    border-radius: 45px;
    font-size: 16px;
    color: #595b56;
    line-height: 24px;
    cursor: pointer;
  }
  li:not(.disabled):not(.cur):hover {
    border: solid 1px #ff3399 !important;
    color: #ff3399;
  }
  /*li:not(:last-child) {
      border-right: solid 1px #D9D9D9;
    }*/
  .cur {
    border: solid 1px #ff3399 !important;
    background-color: #ff3399;
    color: #fff;
  }
  .disabled {
    background-color: #e5e5e5;
    border: solid 1px #e5e5e5;
    color: #aaa;
    cursor: no-drop;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue